import React, { useRef, useEffect, useState } from 'react';
import {
  ChatWindowContainer,
  ChatHeader,
  HeaderActions,
  IconButton,
  MessagesContainer,
  MessageBubble,
  TypingIndicator,
  InputContainer,
  ChatInput,
  SendButton,
  WelcomeMessage
} from './styles';

const RefreshIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z" />
  </svg>
);

const MinimizeIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 13H5v-2h14v2z" />
  </svg>
);

const SendIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
  </svg>
);

function ChatWindow({ messages, isLoading, onSendMessage, onClearChat, onClose }) {
  const [inputValue, setInputValue] = useState('');
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isLoading]);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (inputValue.trim() && !isLoading) {
      onSendMessage(inputValue.trim());
      setInputValue('');
    }
  };

  return (
    <ChatWindowContainer>
      <ChatHeader>
        <h3>Digital Porters Assistant</h3>
        <HeaderActions>
          <IconButton onClick={onClearChat} aria-label="Clear chat" title="Clear chat">
            <RefreshIcon />
          </IconButton>
          <IconButton onClick={onClose} aria-label="Minimize chat" title="Minimize">
            <MinimizeIcon />
          </IconButton>
        </HeaderActions>
      </ChatHeader>

      <MessagesContainer>
        {messages.length === 0 && (
          <WelcomeMessage>
            <h4>Welcome!</h4>
            <p>How can I help you today? Ask me anything about our products and services.</p>
          </WelcomeMessage>
        )}

        {messages.map((message) => (
          <MessageBubble key={message.id} role={message.role}>
            {message.content}
          </MessageBubble>
        ))}

        {isLoading && (
          <TypingIndicator>
            <span />
            <span />
            <span />
          </TypingIndicator>
        )}

        <div ref={messagesEndRef} />
      </MessagesContainer>

      <InputContainer onSubmit={handleSubmit}>
        <ChatInput
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          placeholder="Type a message..."
          disabled={isLoading}
        />
        <SendButton type="submit" disabled={!inputValue.trim() || isLoading} aria-label="Send message">
          <SendIcon />
        </SendButton>
      </InputContainer>
    </ChatWindowContainer>
  );
}

export default ChatWindow;
